import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Timezone, TimezoneCreate, TimezoneFilter } from '../data/timezone';

export function createTimezoneService(client: AxiosInstance) {
  return createCrudService<Timezone, TimezoneCreate, TimezoneFilter>(
    client,
    '/master-data/Timezone',
    'id',
  );
}

export type TimezoneService = CrudService<Timezone, TimezoneCreate, TimezoneFilter>;
